<template>
  <OxApp />
</template>

<script setup>
// oxjob #1689 Nuxt trial: the existing root component, unchanged.
import OxApp from '@/App.vue'
</script>
